import React from 'react';
import { ListItem, ListItemProps } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { useSelectableListContext } from './SelectableListContext';


const CustomListItem = withStyles(ListItem, theme => ({
  root: {
    '&:hover': {
      backgroundColor: theme.palette.secondary.background,
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.secondary.background,

      '&:hover': {
        backgroundColor: theme.palette.secondary.background,
      },
    },
  },
}));


export type SelectableListItemProps<
  D extends React.ElementType = 'li',
  P = {} // eslint-disable-line @typescript-eslint/ban-types
> = ListItemProps<D, P> & {
  value: string;
};



export const SelectableListItem = <
  D extends React.ElementType = 'li',
  P = {} // eslint-disable-line @typescript-eslint/ban-types
>(props: SelectableListItemProps<D, P>) => {
  const selectableListContext = useSelectableListContext();
  const checked = selectableListContext.value === props.value;

  return (
    <CustomListItem
      {...props}
      button
      selected={checked}
      onClick={() => selectableListContext.onChange(props.value)}
    >
      {props.children}
    </CustomListItem>
  );
};
